export function FormContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex flex-col overflow-hidden bg-gray-100 rounded-md p-2 border border-gray-600 min-h-[215px] h-full">
            {children}
        </div>
    );
}
